export const BASE_URL = process.env.BASE_URL || '';
export const Authorization = process.env.Authorization || '';
export const REACT_APP_MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || 'pk.eyJ1Ijoic29icmVzc2FpIiwiYSI6ImNsaGk0dzB0cTA0b2ozcm11Z2FwMDlrOHcifQ.ZGDlyDh1HY5iD7qyILcszQ';

export const headers: any = {
    Authorization,
};

export const politic_default = (
    site: any
) => `Esta Política de Privacidade governa a maneira em que nós da ${
    site?.Dados?.empresa || ''
} coletamos, usamos mantém e divulga informações coletadas dos usuários. Esta política de privacidade aplica-se ao Site e todos os produtos e serviços oferecidos pela ${
    site?.Dados?.empresa || ''
}.

A garantia da confidencialidade dos dados pessoais dos utilizadores do nosso site é importante para o ${
    site?.site || ''
}.

Todas as informações pessoais relativas a membros, assinantes, clientes ou visitantes que usem o ${
    site?.site || ''
} serão tratadas em concordância com a Lei da Proteção de Dados Pessoais de 26 de outubro de 1998 (Lei n.º 67/98) e da LEI Nº 14.010, DE 10 DE JUNHO DE 2020.

A informação pessoal recolhida pode incluir o seu nome, e-mail, número de telefone e/ou telemóvel, morada, data de nascimento e/ou outros.

O uso do ${
    site?.site || ''
} pressupõe a aceitação deste Acordo de privacidade. A equipe do ${
    site?.site || ''
} reserva-se ao direito de alterar este acordo sem aviso prévio. Deste modo, recomendamos que consulte a nossa política de privacidade com regularidade de forma a estar sempre atualizado.`;

export const terms_default = (site: any) => `
Os textos, imagens, gráficos, arquivos de som, arquivos de animação e arquivos de vídeo colocados à disposição no site estão sujeitos a direitos autorais e outras proteções de propriedade intelectual. Estes objetos não podem ser copiados para uso ou distribuição comercial, nem modificados ou reenviados a outros sites. Nada contido neste site deve ser considerado como concessão, licença ou transferência dos poderes dominiais da propriedade intelectual.

Embora a ${
    site?.Dados?.empresa || ''
} procure sempre ser rigorosa na acuidade, precisão e atualização dos recursos, dados e informações dispostos no site, ela não se responsabiliza por quaisquer erros tipográficos, omissões ou imperfeições técnicas, nem por eventuais perdas e danos decorrentes dos mesmos, pois para a Compra ou Aluguel de qualquer imóvel é de suma importância que o cliente visite in loco o mesmo. É de suma importância ressalvar também que as informações contidas no site poderão ser alteradas ou atualizadas sem aviso prévio e que a qualquer instante, podem ocorrer mudanças em produtos, serviços e mesmo na veracidade de informações contidas, sem que tenhamos tido a oportunidade e possibilidade de alterá-los em nosso site.
`;
